import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { SampleEditSessionUrl } from '../SampleEditSessionUrl';

const discardSampleEditSession = async (params: { sessionId: string }) =>
  apiClient
    .delete(expand(SampleEditSessionUrl.discard, params))
    .then((response) => response.data);

export const useDiscardSampleEditSessionMutation = createApiMutationHook(
  ['sample-edit-session-discard'],
  discardSampleEditSession,
);
